import { routerActions } from "connected-react-router";
import { actions as cedipActions } from "reducers/cedip";

const handleClickAcceptAction = (idAccion, receivedCedip, dispatch) => {
    if (idAccion === "transmit.admit") {
        dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT-ADMIT"));

        dispatch(
            cedipActions.setTransmitCedip({
                ...receivedCedip,
                amount: receivedCedip.montoAcobrar,
                beneficiary: {
                    document: `CUIT ${
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].cuitBeneficiario
                    }`,
                    reference:
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].razonSocialBeneficiario,
                },
            }),
        );

        dispatch(
            routerActions.push(`/cedip/transmit/confirmation`, {
                scopeToShow: "cedip/transmit/confirm",
                idActivity: "transmit.admit.cedip.send",
                idTitle: "cedip.transmit.admit",
            }),
        );
    }

    if (idAccion === "transmit.anulate") {
        dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT-ANULATE"));

        dispatch(
            cedipActions.setTransmitCedip({
                ...receivedCedip,
                amount: receivedCedip.montoAcobrar,
                beneficiary: {
                    document: `CUIT ${
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].cuitBeneficiario
                    }`,
                    reference:
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].razonSocialBeneficiario,
                },
            }),
        );

        dispatch(
            routerActions.push(`/cedip/transmit/confirmation`, {
                scopeToShow: "cedip/transmit/confirm",
                idActivity: "transmit.anulate.cedip.send",
                idTitle: "cedip.transmit.anulate",
            }),
        );
    }

    if (idAccion === "transmit.repudiate") {
        dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT-REPUDIATE"));

        dispatch(
            cedipActions.setTransmitCedip({
                ...receivedCedip,
                amount: receivedCedip.montoAcobrar,
                beneficiary: {
                    document: `CUIT ${
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].cuitBeneficiario
                    }`,
                    reference:
                        receivedCedip.transmisiones[receivedCedip.transmisiones.length - 1].razonSocialBeneficiario,
                },
            }),
        );

        dispatch(
            routerActions.push(`/cedip/transmit/confirmation`, {
                scopeToShow: "cedip/transmit/confirm",
                idActivity: "transmit.repudiate.cedip.send",
                idTitle: "cedip.transmit.repudiate",
            }),
        );
    }
};

export default handleClickAcceptAction;
